import { BaseReactiveClass } from './BaseReactiveClass';

export class PortfolioClass extends BaseReactiveClass {
  get investedValue() {
    return this.active_investments || 0;
  }

  get investedValueFunding() {
    return this.funding_investments || 0;
  }

  get distributionsPaidValue() {
    return this.active_paid_investments || 0;
  }

  get geographicProperties() {
    return this.investments_percent_grouped_by_region || {};
  }

  get rowCropProperties() {
    return this.properties_grouped_by_crop_type?.row || 0;
  }

  get permanentCropProperties() {
    return this.properties_grouped_by_crop_type?.perm || 0;
  }

  get timberCropProperties() {
    return this.properties_grouped_by_crop_type?.timber || 0;
  }

  get rowCrops() {
    return this.crops_grouped_by_crop_type?.row || [];
  }

  get permanentCrops() {
    return this.crops_grouped_by_crop_type?.perm || [];
  }

  get timberCrops() {
    return this.crops_grouped_by_crop_type?.timber || [];
  }

  get cropProperties() {
    return this.active_investments_percent_by_farm_crop_type || [];
  }

  get rowCropPropertiesPercent() {
    return this.active_investments_percent_by_farm_crop_type?.row || 0;
  }

  get permanentCropPropertiesPercent() {
    return this.active_investments_percent_by_farm_crop_type?.perm || 0;
  }

  get timberCropPropertiesPercent() {
    return this.active_investments_percent_by_farm_crop_type?.timber || 0;
  }

  get rowCropAmountInvestments() {
    return this.amount_investments_grouped_by_crop_type?.row || 0;
  }

  get permanentCropAmountInvestments() {
    return this.amount_investments_grouped_by_crop_type?.perm || 0;
  }

  get timberCropAmountInvestments() {
    return this.amount_investments_grouped_by_crop_type?.timber || 0;
  }
}
